import { useState } from 'react'
import { Link } from 'react-router'
import { useSignIn } from '../hooks/useAuth'

export function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const signIn = useSignIn()

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    signIn.mutate({ email, password })
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <div className="sidebar-brand-icon">×</div>
          <h1>
            double<span style={{ color: 'var(--accent-primary)' }}>·</span>xl
          </h1>
          <p className="text-muted">Studio OS</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-field">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@double-xl.cloud"
              required
              autoComplete="email"
            />
          </div>
          <div className="form-field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              minLength={8}
              autoComplete="current-password"
            />
          </div>

          {signIn.error && (
            <p className="form-error">
              {(signIn.error as any)?.body?.error?.message || 'Sign in failed'}
            </p>
          )}

          <button
            type="submit"
            className="btn btn-primary btn-full"
            disabled={signIn.isPending}
          >
            {signIn.isPending ? 'Signing in...' : 'Sign in'}
          </button>
          <Link
            to="/forgot-password"
            className="text-muted"
            style={{ textAlign: 'center', display: 'block' }}
          >
            Forgot password?
          </Link>
        </form>
      </div>
    </div>
  )
}
